import { useContext, useState } from "react";
import { LoginService } from "../../service/LoginService";
import ChangePassword from "../parts/ChangePassword";
import { AppFunctions, AppFunctionsContext } from "./App";

/**
 * ヘッダ部分を表すコンポーネント
 * 
 * @returns 
 */
export default function Header(): JSX.Element {

	/** パスワード変更画面を表示するか？ */
	const [changePassword, setChangePassword] = useState<boolean>(false);

	/** APP function */
	const appFunctions = useContext<AppFunctions | undefined>(AppFunctionsContext);

	/** ログイン情報 */
	const login = appFunctions?.getLogin();

	/** タイトルクリック時イベント */
	const handleTitleClick = () => {
		appFunctions?.setPage('dashboard');
	};

	/**
	 * パスワード変更メニュー選択時イベント
	 */
	const handleChangePasswordClick = async () => {
		setChangePassword(true);
	};

	/**
	 * ログアウトメニュー選択時イベント
	 */
	const handleLogoutClick = async () => {
		await new LoginService(appFunctions!).logout(login!.refreshToken);
	};

	// 描画する
	return (
		<div className="navbar navbar-inverse navbar-fixed-top">
			<div className="navbar-inner" style={{ backgroundColor: '#717171', backgroundImage: 'linear-gradient(to bottom, #182d3b, #182d3b)', backgroundRepeat: 'repeat-x', borderColor: '#000080', fontWeight: 'bold' }}>
				<div className="container">
					<a className="btn btn-navbar" data-toggle="collapse"
						data-target=".nav-collapse"> <span className="icon-bar"></span> <span
							className="icon-bar"></span> <span className="icon-bar"></span>
					</a> <a onClick={handleTitleClick} className="brand" style={{ cursor: (login != undefined ? 'pointer' : 'default') }}>Naviexpress Archive Search</a>
					{login != undefined &&
						<div className="nav-collapse collapse">
							<ul className="nav pull-right">
								<li className="dropdown">
									<a href="#" className="dropdown-toggle" data-toggle="dropdown">ログインID：<span>{login.name}</span><b className="caret"></b></a>
									<ul className="dropdown-menu">
										<li><a onClick={handleChangePasswordClick} >パスワード変更</a></li>
										<li><a onClick={handleLogoutClick}>ログアウト</a></li>
									</ul>
								</li>
							</ul>
						</div>
					}
				</div>
			</div>
			{changePassword == true && <ChangePassword onClose={() => setChangePassword(false)} />}
		</div>
	);
}